import React, { Component } from "react";
import axios from "axios";
// import Constants from "../App/Variables/Constants";
import {
  Backdrop,
  Button,
  Container,
  Fade,
  Grid,
  Box,
  //   GridItem,
  Modal,
  TextField,
  Typography,
  Snackbar,
  //   InputLabel,
  //   Select,
  //   MenuItem,
} from "@material-ui/core";
import { Redirect } from "react-router-dom";
import Constants from "../App/Variables/Constants";
import EditIcon from "@material-ui/icons/Edit";
import { Link } from "react-router-dom";
import { Form } from "reactstrap";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import { co } from "co";
import init from "../helpers/WindowToken";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { makeStyles } from "@material-ui/core";

const classes = makeStyles();

export default class UpdateTestimonial extends Component {
  state = {
    _id: "",
    reviews: "",
    name: "",
    position: "",
    pro_pic: "",
    loading: false,
    // notification: false,
    // redirect: false,
  };

  componentDidMount() {
    let id = window.location.pathname.split("/")[3];
    this.setState({
      _id: id,
    });

    if (init() === "success") {
      axios.get(Constants.getUrls.getTestimonialById + id).then((resp) => {
        console.log(resp);
        this.setState({
          reviews: resp.data.single_data.reviews,
          name: resp.data.single_data.name,
          position: resp.data.single_data.position,
          pro_pic: resp.data.single_data.pro_pic,
        });
      });
    }
  }

  handleSubmit = (e) => {
    e.preventDefault();
    // let testimonialLoad = {
    //   _id: this.state._id,
    //   reviews: this.state.reviews,
    //   name: this.state.name,
    //   position: this.state.position,
    //   pro_pic: this.state.pro_pic,
    // };

    let payload = new FormData();
    payload.append("_id", this.state._id);
    payload.append("reviews", this.state.reviews);
    payload.append("name", this.state.name);
    payload.append("position", this.state.position);
    payload.append("pro_pic", this.state.pro_pic);

    console.log(payload);

    this.setState({
      loading: true,
    });
    if (init() === "success") {
      axios
        .put(Constants.putUrls.UpdateTestimonial + this.state._id, payload)
        .then((resp) => {
          console.log(resp);
          this.setState({
            loading: false,
            //   notification: true,
          });
          setTimeout(() => {
            this.setState({
              //  notification: false,
              redirect: true,
            });
          }, 2000);
        });
    }
  };
  // }

  handleStart = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value + "T00:00:00.000Z",
      },
      () => {
        console.log(this.state.startDate);
      }
    );
  };
  handleEnd = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value + "T11:59:59.999Z",
      },
      () => {
        console.log(this.state.endDate);
      }
    );
  };
  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleFile = (e) => {
    if (e.target.name === "pro_pic") {
      this.setState({
        pro_pic: e.target.files[0],
      });
    }
    console.log(this.state.pro_pic);
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to="/testimonials" />;
    } else {
      return (
        <Container maxWidth="xl">
          <Grid container style={{ margin: "10px 0 10px" }} alignItems="center">
            <Grid item xs={6}>
              <Typography variant="h5">Update Testimonial</Typography>
            </Grid>
          </Grid>

          {/* After Getting api add Snackbar notification here  */}

          {this.state.notification ? (
            <Snackbar
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={true}
              color={"green"}
              autoHideDuration={5000}
              message="Testimonial Updated Successfully"
            ></Snackbar>
          ) : null}

          <div
            style={{
              background: "#5b5757",
              padding: "20px",
              borderRadius: "10px",
              width: "100%",
              border: "0",
              display: "flex",
              position: "relative",
              fontSize: ".875rem",
              minWidth: "0",
              wordWrap: " break-word",
              boxShadow: "0 1px 4px 0 rgb(0 0 0 / 14%)",
              marginTop: "30px",
              borderRadius: "6px",
              marginBottom: "30px",
              flexDirection: "column",
              textAlign: "left",
            }}
          >
            <div
              style={{
                background:
                  "linear-gradient(60deg, rgb(128 115 115), rgb(255 250 250)) rgb(153, 153, 153))",
                boxShadow:
                  " rgb(0 0 0 / 14%) 0px 4px 20px 0px, rgb(128 120 120 1/ 40%) 0px 7px 10px -5px",
                float: "left",
                padding: "15px",
                marginTop: "-43px",
                marginRight: "15px",
                borderRadius: "3px",
                backgroundColor: "#999",
                width: "6%",
                height: "60px",
                marginBottom: "25px",
                textAlign: "center",
              }}
            >
              <EditIcon />
            </div>

            <form onSubmit={this.handleSubmit} encType="multipart/form-data">
              <Grid container sm={12} spacing={2}>
                <Grid item sm={4}>
                  <TextField
                    id="outlined-basic"
                    onChange={this.handleInput}
                    label="Reviews"
                    name="reviews"
                    variant="outlined"
                    // required={true}
                    value={this.state.reviews}
                    style={{ marginRignt: "3px", width: "100%" }}
                  />
                </Grid>

                <Grid item sm={4}>
                  <TextField
                    id="outlined-basic"
                    onChange={this.handleInput}
                    label="Name"
                    name="name"
                    variant="outlined"
                    // required={true}
                    style={{ marginRignt: "3px", width: "100%" }}
                    value={this.state.name}
                  />
                </Grid>

                <Grid item sm={4}>
                  <TextField
                    id="outlined-basic"
                    onChange={this.handleInput}
                    label="Position"
                    name="position"
                    variant="outlined"
                    // required={true}
                    style={{ marginRignt: "3px", width: "100%" }}
                    value={this.state.position}
                  />
                </Grid>

                {/* below code commenting for UI down */}

                <Grid item sm={4}>
                  <TextField
                    type="file"
                    id="outlined-basic"
                    onChange={this.handleFile}
                    label="Pro Pic"
                    name="pro_pic"
                    variant="outlined"
                    required={true}
                    style={{ marginRignt: "3px", width: "100%" }}
                  />
                  <img
                    style={{
                      height: "90",
                      width: "90px",
                      marginBottom: "20px",
                      marginRight: "20px",
                    }}
                    src={
                      "https://core.thespaceelement.com" + this.state.pro_pic
                    }
                  />
                </Grid>

                {/* <Grid item sm={4}>
                  <TextField
                    id="outlined-basic"
                    onChange={this.handleInput}
                    label="Skillsets"
                    name="skillset"
                    variant="outlined"
                    // required={true}
                    style={{ marginRignt: "3px", width: "100%" }}
                    value={this.state.skillset}
                  />
                </Grid>

                <Grid item sm={4}>
                  <TextField
                    id="outlined-basic"
                    onChange={this.handleInput}
                    label="Job Role"
                    name="role"
                    variant="outlined"
                    // required={true}
                    style={{ marginRignt: "3px", width: "100%" }}
                    value={this.state.role}
                  />
                </Grid>

                <Grid item sm={4}>
                  <TextField
                    id="outlined-basic"
                    onChange={this.handleInput}
                    label="Functional Area"
                    name="functional_area"
                    variant="outlined"
                    // required={true}
                    style={{ marginRignt: "3px", width: "100%" }}
                    value={this.state.functional_area}
                  />
                </Grid> */}
              </Grid>

              {/* <div style={{ color: "black", marginLeft: "8px", width: "99%" }}>
                <label style={{ color: "white" }}> Description</label>
                <CKEditor
                  editor={ClassicEditor}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    // console.log({ event, editor, data });
                    this.setState({
                      description: data,
                    });
                  }}
                  value={this.state.description}
                  data={this.state.description}
                />
              </div> */}
              <br />
              <div>
                <Button
                  variant="contained"
                  type="submit"
                  size="small"
                  color="primary"
                  style={{
                    marginRight: "20px",
                    width: "15%",
                    marginTop: "35px",
                  }}
                >
                  {this.state.loading ? "Updating.." : "Update Testimonials"}
                </Button>
                <Link
                  to={{
                    pathname: "/testimonials",
                  }}
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    variant="contained"
                    type="submit"
                    size="small"
                    color="secondary"
                    style={{ marginRight: "20px", marginTop: "35px" }}
                  >
                    Cancel
                  </Button>
                </Link>
              </div>
            </form>
          </div>
        </Container>
      );
    }
  }
}
